import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

import { errorPageImage } from 'Assets/Images'

import { Flex, Text as TextUI } from 'Components/UI'

export const Content = styled(Flex).attrs({ py: 123 })`
  background-color: ${themeGet('colors.white')};

  align-items: center;
  flex-direction: column;
  height: 100vh;
  width: 100%;
`

export const ErrorImage = styled(Flex).attrs({
  is: 'img',
  src: errorPageImage,
})`
  width: 350px;
`

export const Text = styled(TextUI).attrs({ is: 'span', mt: 3 })`
  color: ${themeGet('colors.boulder')};
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  line-height: 1.5;
`

export const Button = styled(Flex).attrs({ is: 'button', mt: 4, p: 0 })`
  background-color: ${({ background }) =>
    background || themeGet('colors.goldenrod')};
  border: none;
  border-radius: 0;
  box-shadow: none;
  color: ${({ textcolor }) => textcolor || themeGet('colors.black')};
  cursor: pointer;

  font-family: Inter, sans-serif;
  font-weight: bold;
  font-size: 12px;
  outline: none;
  transition: all 200ms ease;
  text-transform: uppercase;
  user-select: none;

  align-items: center;
  justify-content: center;
  display: flex;
  height: 48px;
  width: 190px;

  &:hover:enabled {
    color: ${themeGet('colors.white')};
  }

  &:active:enabled {
    color: ${themeGet('colors.white')};
  }
`
